'use client';

import { HiCheck } from '@react-icons/all-files/hi/HiCheck';
import Image from 'next/image';
import React from 'react';
import { IAlternative } from '../../types';
import { StyledDiv } from './alternativeContent.styles';

interface IAlternativeContentProps {
    content: IAlternative['content'];
}

export const AlternativeContent = ({ content }: IAlternativeContentProps) => {

    function returnSymbol(symbol: string) {
        if (symbol === 'yes') return <HiCheck className='checked' />;
        if (symbol === 'no') return renderX();
        return renderNone();
    }

    function renderContent(section: IAlternativeContentProps['content'][0], idx: number) {
        if (section.type === 'text') {
            return (
                <div key={`text-${section.title || ''}-${section.text || ''}-${idx}`} className="text-section">
                    {section.title &&
                        <h3>{section.title}</h3>
                    }
                    {section.text &&
                        <div className="p" dangerouslySetInnerHTML={{ __html: section.text }}></div>
                    }
                </div>
            );
        } else if (section.type === 'banner') {
            return (
                <div key={`banner-${section.title || ''}-${idx}`} className={`card-helper-wrapper ${section.bannerStyle}`}>
                    <div className={`banner ${section.bannerAlign}`}>
                        {section.title &&
                            <h3>{section.title}</h3>
                        }
                        {section.bannerType === 'trustpilot' &&
                            <div className="trustpilot-container">
                                {/* <CustomLink variant='secondary' href='https://www.trustpilot.com/review/commoninja.com' target={'_blank'} external={true}> */}
                                <p>Trustpilot</p>
                                {/* </CustomLink> */}
                                {/* <CustomLink variant='secondary' href='https://www.trustpilot.com/review/commoninja.com' target={'_blank'} external={true}> */}
                                <Image src={'/assets/trustpilot.png'} alt='Trustpilot Rating' width={215} height={30} title='4.3 stars out of 5' />
                                {/* </CustomLink> */}
                            </div>
                        }
                        {(section.text && section.bannerType !== 'trustpilot') &&
                            <div className="banner-text" dangerouslySetInnerHTML={{ __html: section.text }}></div>
                        }
                    </div>
                </div>
            );
        } else {
            return (
                <div key={`table-${section.title || ''}-${idx}`} className="table-wrapper">
                    {section.title &&
                        <h3>{section.title}</h3>
                    }
                    {section.text &&
                        <div className="p" dangerouslySetInnerHTML={{ __html: section.text }}></div>
                    }
                    <table >
                        <thead>
                            <tr>
                                {section.showFeatures &&
                                    <th></th>
                                }
                                <th className='first-td'>{section.tableHeader1}</th>
                                <th>{section.tableHeader2}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {section.tableRows.map((row, idx) => {
                                if (row.type === 'symbol') {
                                    return (
                                        <tr className={row.tableType || ''} key={`row-${idx}`}>
                                            {section.showFeatures &&
                                                <td>{row.featureName || ''}</td>
                                            }
                                            <td className='first-td'>
                                                {returnSymbol(row.header1Symbol || '')}
                                                {row.header1SymbolNote &&
                                                    <p className='note'>
                                                        {row.header1SymbolNote}
                                                    </p>
                                                }
                                            </td>
                                            <td>
                                                {returnSymbol(row.header2Symbol || '')}
                                                {row.header2SymbolNote &&
                                                    <p className='note'>
                                                        {row.header2SymbolNote}
                                                    </p>
                                                }
                                            </td>
                                        </tr>
                                    );
                                }

                                return (
                                    <tr className={row.tableType || ''} key={`row-${idx}`}>
                                        {section.showFeatures &&
                                            <td>{row.featureName || ''}</td>
                                        }
                                        <td className='first-td' dangerouslySetInnerHTML={{ __html: row.header1Text || '' }}></td>
                                        <td dangerouslySetInnerHTML={{ __html: row.header2Text || '' }}></td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            );
        }

    }
    return (
        <StyledDiv>
            {content.map((section, idx) => {
                return renderContent(section, idx);
            })}
        </StyledDiv>
    );
};

function renderThrowingStars() {
    return (
        <svg className='throwing-stars' width="198" height="151" viewBox="0 0 198 151" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M95.2554 42.6991C94.7158 40.941 96.6352 39.4479 98.2065 40.4034L132.098 61.0123C132.281 61.1236 132.481 61.2047 132.69 61.2527L171.348 70.1332C173.141 70.5449 173.474 72.9537 171.861 73.8368L137.067 92.8834C136.88 92.9862 136.709 93.1185 136.564 93.2753L109.543 122.315C108.291 123.661 106.038 122.745 106.08 120.907L106.982 81.2513C106.987 81.0372 106.957 80.8237 106.894 80.619L95.2554 42.6991Z" fill="#6278D4" />
            <path fillRule="evenodd" clipRule="evenodd" d="M25.7907 35.926C26.1869 36.4956 26.0702 37.2748 25.5246 37.7034L14.8923 46.052C14.516 46.3475 14.0085 46.4143 13.5686 46.2259C13.1287 46.0373 12.8266 45.6237 12.7811 45.1478L11.4878 31.6915C11.4213 31.001 11.9052 30.3785 12.5907 30.2725C13.4343 30.1421 14.1379 29.5974 14.4727 28.8152C14.7304 28.2135 14.7385 27.5475 14.4952 26.9397C14.252 26.332 13.7866 25.8555 13.1849 25.5977L13.1848 25.5976C12.4067 25.2643 11.5246 25.3533 10.8253 25.836C10.2561 26.2288 9.47943 26.111 9.05218 25.567L0.6712 14.8934C0.593176 14.7939 0.531073 14.6853 0.485495 14.5714C0.358296 14.2536 0.3587 13.8932 0.497445 13.5695C0.685847 13.1296 1.09922 12.8277 1.57553 12.782L15.0841 11.4837C15.7726 11.4175 16.3935 11.8982 16.5022 12.5815C16.6351 13.4209 17.1795 14.1206 17.9577 14.4539C18.5595 14.7116 19.2256 14.7196 19.8333 14.4764C20.4411 14.2331 20.9176 13.7677 21.1753 13.166C21.5103 12.3839 21.4197 11.4988 20.9316 10.7983C20.5353 10.2281 20.6521 9.44934 21.1977 9.02088L31.83 0.672358C32.2064 0.376916 32.7138 0.310125 33.1537 0.498527C33.5935 0.686978 33.8955 1.1003 33.9413 1.57661L35.2344 15.0329C35.3009 15.7235 34.817 16.3459 34.1315 16.4519C33.2879 16.5823 32.5844 17.127 32.2493 17.9093C31.7176 19.1512 32.2952 20.5946 33.5374 21.1268C34.3157 21.4602 35.1978 21.3711 35.897 20.8886C36.4662 20.4958 37.2428 20.6136 37.6701 21.1575L46.0512 31.8311C46.3468 32.2078 46.4133 32.7151 46.225 33.1548C46.0366 33.5947 45.6232 33.8966 45.1469 33.9424L31.6383 35.2405C30.9499 35.3068 30.3287 34.8266 30.2202 34.1427C30.0874 33.3039 29.543 32.6038 28.7645 32.2702C27.5223 31.7383 26.079 32.316 25.547 33.5582C25.212 34.3403 25.303 35.226 25.7907 35.926ZM27.4152 21.7682C27.8504 22.8556 27.8362 24.0474 27.3751 25.1242C26.9139 26.201 26.061 27.0335 24.9736 27.4688C23.8862 27.9041 22.6943 27.8899 21.6176 27.4287C20.5408 26.9675 19.7083 26.1146 19.273 25.0272C18.8377 23.9398 18.8519 22.748 19.3131 21.6712C19.7743 20.5945 20.6271 19.7619 21.7146 19.3266C22.802 18.8914 23.9938 18.9056 25.0706 19.3667C26.1473 19.8279 26.9799 20.6808 27.4152 21.7682Z" fill="#6278D4" />
        </svg>
    );
}

function renderSword() {
    return (
        <svg className='sword' width="191" height="191" viewBox="0 0 191 191" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M132.325 45.8989L144.976 54.5826C69.5361 164.835 32.4579 184.463 16.8889 189.972C15.5264 190.442 14.0203 189.899 13.2714 188.667C12.5225 187.436 12.7334 185.849 13.7779 184.855C28.6355 170.52 68.8742 134.993 132.325 45.8989Z" fill="#6278D4" />
            <path d="M145.186 26.5189L164.703 29.5666L156.259 40.0499L142.508 30.6177L145.186 26.5189Z" fill="#6278D4" />
            <path d="M165.024 1.31293L176.392 9.26175C177.202 9.66463 177.792 10.4046 178.005 11.2836C178.218 12.1625 178.031 13.0906 177.496 13.8193L169.052 24.3026L159.62 4.69085L161.056 2.49609C161.871 1.13236 163.594 0.618615 165.024 1.31293Z" fill="#6278D4" />
            <path d="M155.705 10.537L161.652 22.8788L148.88 20.901L155.705 10.537Z" fill="#6278D4" />
            <path d="M162.171 55.2206C161.218 56.6084 159.324 56.9674 157.93 56.0245L125.574 33.831C124.34 32.8267 124.08 31.0446 124.976 29.7295C125.872 28.4144 127.626 28.0042 129.012 28.7854L161.367 50.9789C162.755 51.9318 163.114 53.826 162.171 55.2206Z" fill="#6278D4" />
        </svg>
    );
}

function renderX() {
    return (
        <svg className='x' width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.3578 3.74235L12.6009 9.49987L18.3578 15.2571C19.2141 16.1138 19.2141 17.5014 18.3578 18.3581C17.9299 18.7859 17.369 19 16.8083 19C16.2467 19 15.6857 18.7862 15.2582 18.3581L9.50003 12.6001L3.74232 18.358C3.31452 18.7859 2.75352 18.9999 2.19236 18.9999C1.63136 18.9999 1.07074 18.7862 0.642559 18.358C-0.21375 17.5017 -0.21375 16.114 0.642559 15.2571L6.39928 9.49981L0.642232 3.74235C-0.214077 2.88603 -0.214077 1.49806 0.642232 0.641745C1.49838 -0.213915 2.88552 -0.213915 3.74199 0.641745L9.49997 6.39927L15.2575 0.641745C16.1142 -0.213915 17.5015 -0.213915 18.3574 0.641745C19.2141 1.49806 19.2141 2.88603 18.3578 3.74235Z" fill="#A9A9A9" />
        </svg>
    );
}

function renderNone() {
    return (
        <svg width="8" height="18" viewBox="0 0 8 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.95897 7.99532L7.43314 2.49243C7.65245 1.67396 7.16686 0.832905 6.34819 0.613707C5.53015 0.394678 4.6895 0.88003 4.46976 1.69822L2.9952 7.20133L2.20103 10.1649L0.72687 15.6676C0.507793 16.4865 0.99328 17.3273 1.81173 17.5466C2.22099 17.6563 2.63549 17.5897 2.97544 17.3934C3.31548 17.1971 3.58052 16.8711 3.69006 16.4622L5.16461 10.9588L5.95897 7.99532Z" fill="#D9D9D9" />
        </svg>
    );
}